import { useQuery } from "react-query";
import apiService from "../../service/apiService";
import { useCookie } from "../useCookie";
import { apiConfig } from "../../config/apiConfig";

export type PlacePendingAmountBreakdownItem = {
  id: string;
  name: string;
  amount: number;
  bookingsCount: number;
};

export type PlacePendingAmountBreakdownResponse = {
  events: PlacePendingAmountBreakdownItem[];
  offers: PlacePendingAmountBreakdownItem[];
  packs: PlacePendingAmountBreakdownItem[];
};

export const usePlacePendingAmountBreakdown = (placeId?: string | null) => {
  const { token } = useCookie("vToken");

  const { data, isLoading, isFetching, refetch } = useQuery(
    ["placePendingAmountBreakdown", placeId],
    () =>
      apiService.MakeGetRequest<PlacePendingAmountBreakdownResponse>(
        apiConfig.payment.pendingAmountBreakdown(placeId as string),
        token,
      ),
    {
      enabled: Boolean(placeId && token),
    },
  );

  return {
    events: data?.events ?? [],
    offers: data?.offers ?? [],
    packs: data?.packs ?? [],
    isLoading,
    isFetching,
    refetch,
  };
};
